module.exports = __webpack_public_path__ + "img/non-mechanical.f5454e42.jpg";